import { BaseInputModel } from '@/helpers/entities/models/BaseInputModel';
import { State } from '@/helpers/entities/enums/v2/State';
export class CartPromoProductInputModel extends BaseInputModel {
    constructor(payload = null) {
        super();
        if (payload) {
            Object.assign(this, payload);
            this.state = State.idle;
            this.persistent = true;
        }
        else {
            this.init();
        }
    }
    init() {
        this.uuid = null;
        this.state = State.new;
    }
}
